import { motion } from "framer-motion";
import { FileText } from "lucide-react";
import { SITE } from "@/data/content";

const NAV = [
    { label: "about", href: "#bio", testid: "nav-link-about" },
    { label: "portfolio", href: "#portfolio", testid: "nav-link-portfolio" },
    { label: "contact", href: "#contact", testid: "nav-link-contact" },
];

export default function SiteNav() {
    return (
        <motion.header
            initial={{ y: -24, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="fixed inset-x-0 top-0 z-50 border-b border-[#E5E1D8]/50 bg-[#FBF9F5]/80 backdrop-blur-md"
        >
            <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4 sm:px-10">
                <a
                    href="#home"
                    data-testid="nav-brand-logo"
                    className="font-serif text-xl italic tracking-tight text-[#141413]"
                >
                    {SITE.wordmark}
                </a>
                <nav className="flex items-center gap-5 sm:gap-7">
                    {NAV.map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            data-testid={item.testid}
                            className="u-link text-xs tracking-[0.18em] text-[#141413]/60 transition-colors duration-300 hover:text-[#141413] sm:text-sm"
                        >
                            {item.label}
                        </a>
                    ))}
                    <a
                        href={SITE.resume}
                        data-testid="nav-button-resume"
                        className="hidden items-center gap-1.5 rounded-full border border-[#141413]/20 px-3.5 py-1.5 text-xs tracking-wide text-[#141413] transition-colors duration-300 hover:border-[#C84B31] hover:bg-[#C84B31] hover:text-[#FBF9F5] sm:flex"
                    >
                        <FileText size={13} strokeWidth={1.75} />
                        resume
                    </a>
                </nav>
            </div>
        </motion.header>
    );
}
